// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9Lwef","fullView":"styles_fullView__3BIPZ"};